import React from 'react';
import Button from '../ui/Button';
import Dialog from '../ui/Dialog/Dialog';
import { Field, Input } from '../ui/Field/Field';

// Asks for an expiry date, then runs the search.
const ExpiryModal = ({ isOpen, onClose, expiryDate, setExpiryDate, onSearch }) => {
    if (!isOpen) return null;

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && expiryDate) {
            e.preventDefault();
            onSearch();
        }
    };

    return (
        <Dialog
            open
            onClose={onClose}
            size="sm"
            title="Select Expiry Date"
            footer={(
                <>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button variant="primary" onClick={onSearch} disabled={!expiryDate}>
                        Show Cars
                    </Button>
                </>
            )}
        >
            <Field label="Expiry date">
                <Input
                    type="date"
                    value={expiryDate}
                    onChange={(e) => setExpiryDate(e.target.value)}
                    onKeyDown={handleKeyDown}
                    data-autofocus
                />
            </Field>
        </Dialog>
    );
};

export default ExpiryModal;
